import * as React from "react";
import { useTranslation } from "react-i18next";
import CommonContainer from "../../../components/common/container/CommonContainer";
import { AdvertisementsForm } from "../../../components";

const CreateAdvertisement: React.FC = () => {
  const { t } = useTranslation('translation');

  return (
    <CommonContainer title={t("createAd")} description={t("createAdPageDescription")}>
      <AdvertisementsForm />
    </CommonContainer>
  );
};

export default CreateAdvertisement;
